const validate = (value, args) => {
  let regex = /^(\d{9})$/
  if (!regex.test(value)) {
    return false
  }

  if (!value.toString().startsWith('4')) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'The number must start with 4 and consist of 9 digits'
  }
}
